export class ApiReleaseHelper {
    public static serviceValues  =[
        {value: 'all', label: 'General'},
        {value: 'domestic_road', label: 'Domestic Road'},
        {value: 'international_road', label: 'International Road'},
    ];
}